import { RemoveTokenFromLocalStorage } from "../components/Account/AuthenticationContext";
import { Redirect } from "../components/Utilities";

const LogOut = (): any => {
  RemoveTokenFromLocalStorage();
  return (
    <>
      <Redirect path="/login" isLogout={true} />
    </>
  );
};

export default LogOut;
